import {EntityWithId, EntityWithIdAndDescription} from "../baseEntities";
import {AddressFormData} from "../../pages/solicitation-new/steps/components/components-company-data/DialogAddress";

export enum ClientFields {
    Id = 'idCliente',
    ParentId = 'idClientePadre',
    BusinessName = 'razonSocial',
    IdentificationNumber = 'numeroDocumento',
    CUIT = 'cuit',
    IncomeTaxRegistered = 'estaInscriptoEnGanancias',
    GrossIncomeRegistered = 'estaInscriptoEnIngresosBrutos',
    BlockedEmail = 'tieneMailBloqueo',
    ActivityStartDate = 'actividadFechaInicio',
    AfipRegisterDate = 'afipFechaInscripcion',
    BirthDate = 'fechaNacimiento',

    ClientTypeCode = 'codClienteTipo',
    ClientTypeDesc = 'descClienteTipo',
    ClientClassificationCode = 'codClienteClasificacion',
    ClientClassificationDesc = 'descClienteClasificacion',
    AfipResponsibilityTypeCode = 'codAfipResponsableTipo',
    AfipResponsibilityTypeDesc = 'descAfipResponsableTipo',
    MaritalStatusCode = 'codEstadoCivil',
    MaritalStatusDesc = 'descEstadoCivil',
    NationalityCode = 'codNacionalidad',
    GenderCode = 'codClienteGenero',

    LastFiscalAddress = 'ultimoDomicilioFiscal',
    LastCellNumber = 'ultimoCelular',
    LastPhoneNumber = 'ultimoTelefono',
    LastMail = 'ultimoMail',

    AfipMainActivityDesc = 'descAfipActividadPrincipal',
    AfipAreaDesc = 'descAfipRubro',
    AfipSectorDesc = 'descAfipSector',
    AfipSepymeDesc = 'descAfipRamoSepyme',
    AfipStretchCode = 'codAfipTramo',
    AfipStretchDesc = 'descAfipTramo',

    PymeCertificateNumber = 'vchNroCertificadoPyme',
    PymeCertificateDate = 'dtmFechaCertificadoPyme',
    PymeCertificateIssueDate = 'dtmFechaEmisionCertificadoPyme',
    SepymeCertificate = 'vchAfipRamoSepymeCertificado',
    AfipStretchCertificate = 'vchDescAfipTramoCertificadoPyme',
    Website = 'sitioWeb',
    CommercialName = 'nombreComercial',

    PartnerCuit = 'cuitConyugue'
}

export enum AfipResponsabilityTypeFields {
    CondorId = 'vchIdCondor',
    Monotax = 'bitMonotributista'
}

export interface AfipResponsabilityType extends EntityWithIdAndDescription {
    [AfipResponsabilityTypeFields.CondorId]: string;
    [AfipResponsabilityTypeFields.Monotax]?: boolean;
}

export interface Client extends EntityWithId<number> {
    [ClientFields.Id]: number;
    [ClientFields.ParentId]: number;
    [ClientFields.BusinessName]: string;
    [ClientFields.IdentificationNumber]: string;
    [ClientFields.CUIT]: string;
    [ClientFields.IncomeTaxRegistered]: boolean;
    [ClientFields.GrossIncomeRegistered]: boolean;
    [ClientFields.BlockedEmail]: boolean;
    [ClientFields.ActivityStartDate]: Date;
    [ClientFields.AfipRegisterDate]: Date;
    [ClientFields.ClientTypeCode]: number;
    [ClientFields.ClientTypeDesc]: string;
    [ClientFields.ClientClassificationCode]: number;
    [ClientFields.ClientClassificationDesc]: string;
    [ClientFields.AfipResponsibilityTypeCode]: number;
    [ClientFields.AfipResponsibilityTypeDesc]: string;
    [ClientFields.MaritalStatusCode]: number;
    [ClientFields.MaritalStatusDesc]: string;

    [ClientFields.GenderCode]: number;
    [ClientFields.NationalityCode]: number;
    [ClientFields.BirthDate]: Date;

    [ClientFields.LastFiscalAddress]: string;
    [ClientFields.LastCellNumber]: string;
    [ClientFields.LastPhoneNumber]: string;
    [ClientFields.LastMail]: string;

    [ClientFields.AfipMainActivityDesc]: string;
    [ClientFields.AfipAreaDesc]: string;
    [ClientFields.AfipSectorDesc]: string;
    [ClientFields.AfipSepymeDesc]: string;
    [ClientFields.AfipStretchCode]: number;
    [ClientFields.AfipStretchDesc]: string;

    [ClientFields.PymeCertificateNumber]: string;
    [ClientFields.PymeCertificateDate]: string;
    [ClientFields.PymeCertificateIssueDate]: string;
    [ClientFields.SepymeCertificate]: string;
    [ClientFields.AfipStretchCertificate]: string;
    [ClientFields.CommercialName]: string,
    [ClientFields.Website]: string,
    [ClientFields.PartnerCuit]: string
}


export enum ClientAddressFields {
    Id = 'id',
    ClientId = 'intIdCliente',
    AddressTypeCode = 'tinCodDomicilioTipo',
    Street = 'vchCalle',
    StreetNumber = 'vchCalleNro',
    Floor = 'vchPiso',
    Apartment = 'vchDepto',
    Neighborhood = 'vchBarrio',
    PostalCode = 'vchCP',
    MunicipalityCode = 'intCodLocalidad',
    DepartmentCode = 'intCodPartido',
    ProvinceCode = 'intCodProvincia',
    CountryCode = 'sinCodPais',
    OriginId = 'vchIdEnOrigen',
    Verified = 'bitVerificado',
    Active = 'bitActivo',
    Observations = 'vchObservaciones',
    AddressTypeDesc = 'vchDescDomicilioTipo',
    MunicipalityDesc = 'vchDescLocalidad',
    DepartmentDesc = 'vchDescPartido',
    ProvinceDesc = 'vchDescProvincia',
    StreetWithNumber = 'vchCalleCompleta',
    FullAddress = 'vchCalleCompletaConTipoDomicilio',
    LastModified = 'dtmFechaUltMod',
    OriginCode = 'sinCodOrigen',
    ModuleCode = 'tinCodModulo',
    GroupId = 'intIdGrupo',
}

export interface ClientForm extends EntityWithId<number> {
    [ClientFields.ClientTypeCode]: number;
    [ClientFields.BusinessName]: string;
    [ClientFields.MaritalStatusCode]: number;
    [ClientFields.ActivityStartDate]: Date;
    [ClientFields.AfipResponsibilityTypeCode]: number | null;
    [ClientFields.BirthDate]: Date | string;
    [ClientFields.NationalityCode]: number;
    [ClientFields.AfipRegisterDate]: Date;
    [ClientFields.ClientClassificationCode]: number;
    [ClientFields.GenderCode]: number;
    [ClientFields.IncomeTaxRegistered]: boolean;
    [ClientFields.GrossIncomeRegistered]: boolean;
    [ClientFields.AfipStretchCode]: number;
    [ClientFields.CommercialName]?: string,
    [ClientFields.Website]?: string
}

export interface ClientAddress extends EntityWithId<number> {
    [key: string]: any;

    [ClientAddressFields.Id]: number;
    [ClientAddressFields.ClientId]: number;
    [ClientAddressFields.AddressTypeCode]: number;
    [ClientAddressFields.Street]: string;
    [ClientAddressFields.StreetNumber]: string;
    [ClientAddressFields.Floor]: string;
    [ClientAddressFields.Apartment]: string;
    [ClientAddressFields.Neighborhood]: string;
    [ClientAddressFields.PostalCode]: string;
    [ClientAddressFields.MunicipalityCode]: number | null;
    [ClientAddressFields.DepartmentCode]: number | null;
    [ClientAddressFields.ProvinceCode]: number | null;
    [ClientAddressFields.CountryCode]: number | null;
    [ClientAddressFields.OriginId]: string;
    [ClientAddressFields.Verified]: boolean;
    [ClientAddressFields.Active]: boolean;
    [ClientAddressFields.Observations]: string;
    [ClientAddressFields.AddressTypeDesc]: string;
    [ClientAddressFields.MunicipalityDesc]: string;
    [ClientAddressFields.DepartmentDesc]: string;
    [ClientAddressFields.ProvinceDesc]: string;
    [ClientAddressFields.StreetWithNumber]: string;
    [ClientAddressFields.FullAddress]: string;
    [ClientAddressFields.LastModified]: string | null;
    [ClientAddressFields.OriginCode]: number | null;
    [ClientAddressFields.ModuleCode]: number | null;
    [ClientAddressFields.GroupId]: number | null;
}

export enum ClientAddressTypes {
    Fiscal = 1,
    Legal = 2,
    Real = 3,
    Actividad = 4
}


export enum ClientPhoneNumberFields {
    Id = 'id',
    ClientId = 'intIdCliente',
    PhoneTypeCode = 'tinCodTelefonoTipo',
    AreaCode = 'vchCodigoArea',
    PhoneNumber = 'vchTelefono',
    OriginId = 'vchIdEnOrigen',
    Verified = 'bitVerificado',
    Active = 'bitActivo',
    PhoneNumberWithAreaCode = 'vchTelefoConCodigoArea',
    FullPhoneNumber = 'vchMostrarDescTelefonoTipoYTelefono',
    PhoneTypeDesc = 'vchDescTelefonoTipo',
    LastModified = 'dtmFechaUltMod',
    OriginCode = 'sinCodOrigen',
    ModuleCode = 'tinCodModulo',
    GroupId = 'intIdGrupo',
}

export interface ClientPhoneNumber extends EntityWithId<number> {
    [key: string]: any;
    [ClientPhoneNumberFields.Id]: number;
    [ClientPhoneNumberFields.ClientId]: number;
    [ClientPhoneNumberFields.PhoneTypeCode]: number;
    [ClientPhoneNumberFields.AreaCode]: string;
    [ClientPhoneNumberFields.PhoneNumber]: string;
    [ClientPhoneNumberFields.OriginId]: string;
    [ClientPhoneNumberFields.Verified]: boolean;
    [ClientPhoneNumberFields.Active]: boolean;
    [ClientPhoneNumberFields.PhoneNumberWithAreaCode]: string;
    [ClientPhoneNumberFields.FullPhoneNumber]: string;
    [ClientPhoneNumberFields.PhoneTypeDesc]: string;
    [ClientPhoneNumberFields.LastModified]: string | null;
    [ClientPhoneNumberFields.OriginCode]: number | null;
    [ClientPhoneNumberFields.ModuleCode]: number | null;
    [ClientPhoneNumberFields.GroupId]: number | null;
}

export enum AddressDataFields {
    PostalCode = 'vchCodPostal',
    Municipalities = 'lstLocalidades',
    Departments = 'lstPartidos',
    Provinces = 'lstProvincias',
}

export interface AddressDataWithPostalCode {
    [AddressDataFields.PostalCode]: string;
    [AddressDataFields.Municipalities]: Municipality[];
    [AddressDataFields.Departments]: Department[];
    [AddressDataFields.Provinces]: Province[];
}

export enum MunicipalityFields {
    ProvinceCode = 'intCodProvincia',
    CountryCode = 'sinCodPais',
    DepartmentCode = 'intCodPartido',
}

export interface Municipality extends EntityWithIdAndDescription {
    [MunicipalityFields.ProvinceCode]: number;
    [MunicipalityFields.CountryCode]: number;
    [MunicipalityFields.DepartmentCode]: number;
}

export enum DepartmentFields {
    ProvinceCode = 'intCodProvincia',
    CountryCode = 'sinCodPais'
}

export interface Department extends EntityWithIdAndDescription {
    intCodProvincia: number;
    sinCodPais: number;
}

export enum ProvinceFields {
    CountryCode = 'sinCodPais',
}

export interface Province extends EntityWithIdAndDescription {
    [ProvinceFields.CountryCode]: number;
}

export enum PhoneTypes {
    Telefono = 0,
    Celular = 1,
    Particular = 2,
    Laboral = 3,
}


export enum ClientUserDTOFields {
    ClientId = 'idCliente',
    UserId = 'idUsuario',
    StartDate = 'fechaAlta',
    BusinessName = 'razonSocial',
    CUIT = 'cuit'
}


export interface ClientUserDTO extends EntityWithId<number> {
    [ClientUserDTOFields.ClientId]: number,
    [ClientUserDTOFields.UserId]: number,
    [ClientUserDTOFields.StartDate]: Date,
    [ClientUserDTOFields.BusinessName]: string,
    [ClientUserDTOFields.CUIT]: string
}

export enum ClientRelationshipInsertFields {
    RelationshipTypeCode = "tipoRelacion",
    RelationshipClassificationTypeCode = "clasificacionRelacion",
    Participation = "porcParticipacion",
    Signer = "esFirmante"
}

export interface ClientRelationshipInsert {
    [ClientRelationshipInsertFields.RelationshipTypeCode]: number;
    [ClientRelationshipInsertFields.RelationshipClassificationTypeCode]: number;
    [ClientRelationshipInsertFields.Participation]: number;
    [ClientRelationshipInsertFields.Signer]: boolean;
}

export enum ClientType {
    Fisica = 1,
    Juridica = 2
}

export enum ClientClassificationTypes {
    SH = 1,
    SRL = 2,
    SA = 3,
    COOP = 4,
    OTR = 5,
    SAS = 6,
    SCA = 7,
    SCS = 8,
    UTE = 9,
}


export interface ClientRelationshipType extends EntityWithIdAndDescription {
    [ClientRelationshipTypeFields.Id]: number;
    [ClientRelationshipTypeFields.Description]: string;
    [ClientRelationshipTypeFields.ClientRelationshipClassificationCode]: number;
    [ClientRelationshipTypeFields.EditSigner]: boolean;
    [ClientRelationshipTypeFields.EditParticipation]: boolean;
}

export enum ClientRelationshipViewFields {
    ClientId = 'idCliente',
    Participation = 'porcParticicacion',
    BusinessName = 'razonSocial',
    CUIT = 'cuit',
    Lastname = 'apellido',
    Firstname = 'nombre',
    IdentificationNumber = 'numeroDocumento',
    BirthDate = 'fechaNacimiento',
    ClientTypeDesc = 'descClienteTipo',
    RelationshipTypeCode = 'codClienteRelacionTipo',
    RelationshipTypeDesc = 'descClienteRelacionTipo',
    RelationshipClassificationCode = 'codClienteRelacionClasificacion',
    RelationshipClassificationDesc = 'descClienteClasificacion',
    Signer = 'esFirmante',
    Active = 'estaActivo',
    LastModified = 'fechaModificacion'
}

export interface ClientRelationshipView extends EntityWithIdAndDescription{
    [ClientRelationshipViewFields.ClientId]: number;
    [ClientRelationshipViewFields.Participation]: number;
    [ClientRelationshipViewFields.BusinessName]: string;
    [ClientRelationshipViewFields.CUIT]: string;
    [ClientRelationshipViewFields.Lastname]: string;
    [ClientRelationshipViewFields.Firstname]: string;
    [ClientRelationshipViewFields.IdentificationNumber]: string;
    [ClientRelationshipViewFields.BirthDate]: Date;
    [ClientRelationshipViewFields.ClientTypeDesc]: string;
    [ClientRelationshipViewFields.RelationshipTypeCode]: number;
    [ClientRelationshipViewFields.RelationshipTypeDesc]: string;
    [ClientRelationshipViewFields.RelationshipClassificationCode]: number;
    [ClientRelationshipViewFields.RelationshipClassificationDesc]: string;
    [ClientRelationshipViewFields.Signer]: boolean;
    [ClientRelationshipViewFields.Active]: boolean;
    [ClientRelationshipViewFields.LastModified]: Date;
}

export enum ClientRelationshipTypeFields {
    Id = 'id',
    Description = 'descripcion',
    ClientRelationshipClassificationCode = 'tinCodClienteRelacionClasificacion',
    EditSigner = 'bitEditaEsFirmante',
    EditParticipation = 'bitEditaParticipacion',
}

export interface ClientRelationshipType extends EntityWithIdAndDescription {
    [ClientRelationshipTypeFields.Id]: number;
    [ClientRelationshipTypeFields.Description]: string;
    [ClientRelationshipTypeFields.ClientRelationshipClassificationCode]: number;
    [ClientRelationshipTypeFields.EditSigner]: boolean;
    [ClientRelationshipTypeFields.EditParticipation]: boolean;
}


export enum CoOwnerRelationshipWithoutSolicitationFields {
    CoOwnerRelationship = 'relacionCotitular',
    MaritalRelationship = 'relacionConyuge',
    FianceId = 'idConyuge',
    Address = 'direccion',
    FianceName = 'razonSocialConyugue',
    FianceCuit = 'cuitConyugue'
}

export interface CoOwnerRelationshipWithoutSolicitation extends EntityWithId<number> {
    [ClientFields.CUIT]: string;
    [ClientFields.BusinessName]: string;
    [ClientFields.IdentificationNumber]: string;
    [ClientFields.BirthDate]: Date;
    [ClientFields.GenderCode]: number;
    [ClientFields.MaritalStatusCode]: number;
    [ClientFields.AfipResponsibilityTypeCode]: number;
    [ClientFields.ClientTypeCode]: number;
    [ClientFields.ClientClassificationCode]: number;
    [ClientRelationshipViewFields.Participation]: number;
    [ClientRelationshipViewFields.RelationshipTypeCode]: number;
    [ClientFields.Id]: number;
    [CoOwnerRelationshipWithoutSolicitationFields.FianceId]: number;
    [CoOwnerRelationshipWithoutSolicitationFields.FianceName]: string,
    [CoOwnerRelationshipWithoutSolicitationFields.FianceCuit]: string,
    [CoOwnerRelationshipWithoutSolicitationFields.CoOwnerRelationship]: ClientRelationshipInsert[];
    [CoOwnerRelationshipWithoutSolicitationFields.MaritalRelationship]: ClientRelationshipInsert[];
    [CoOwnerRelationshipWithoutSolicitationFields.Address]?: AddressFormData
}


export enum ClientAfipActivityFields {
    Id = 'id',
    ClientId = 'intIdCliente',
    AfipActivityCode = 'intCodAfipActividad',
    IsMainActivity = 'bitActividadPrincipal',
    AfipActivityStartDate = 'dtmFechaInicioActividad',
    BeginDate = 'dtmFechaAlta',
    AfipAreaCode = 'sinCodAfipRubro',
    AfipSectorCode = 'sinCodAfipSector',
    AfipSepymeCode = 'sinCodAfipRamoSepyme',
    AfipActivityDesc = 'vchDescAfipActividad',
    AfipAreaDesc = 'vchDescAfipRubro',
    AfipSectorDesc = 'vchDescAfipSector',
    AfipSepymeDesc = 'vchAfipRamoSepyme',
}

export interface ClientAfipActivity extends EntityWithId<number> {
    [ClientAfipActivityFields.ClientId]: number;
    [ClientAfipActivityFields.AfipActivityCode]: number;
    [ClientAfipActivityFields.IsMainActivity]: boolean;
    [ClientAfipActivityFields.AfipActivityStartDate]: Date
    [ClientAfipActivityFields.BeginDate]: Date;
    [ClientAfipActivityFields.AfipAreaCode]: number;
    [ClientAfipActivityFields.AfipSectorCode]: number;
    [ClientAfipActivityFields.AfipSepymeCode]: number;
    [ClientAfipActivityFields.AfipActivityDesc]: string;
    [ClientAfipActivityFields.AfipAreaDesc]: string;
    [ClientAfipActivityFields.AfipSectorDesc]: string;
    [ClientAfipActivityFields.AfipSepymeDesc]: string;
}

export enum ClientMailFields {
    ClientId = 'intIdCliente',
    ClientMailId = 'intIdClienteMail',
    MailTypeCode = 'tinCodMailTipo',
    Mail = 'vchMail',
    OriginId = 'vchIdEnOrigen',
    Verified = 'bitVerificado',
    Active = 'bitActivo',
    MailTypeDesc = 'vchMailTipo',
    ModuleDesc = 'vchDescModulo',
    MailDescAndTypeDesc = 'vchMostrarDescMailTipoYMail',
    LastModified = 'dtmFechaUltMod',
}

export interface ClientMail extends EntityWithId<number> {
    [ClientMailFields.ClientId]: number;
    [ClientMailFields.ClientMailId]: number;
    [ClientMailFields.MailTypeCode]: number;
    [ClientMailFields.Mail]: string;
    [ClientMailFields.OriginId]: string;
    [ClientMailFields.Verified]: boolean;
    [ClientMailFields.Active]: boolean;
    [ClientMailFields.MailTypeDesc]: string;
    [ClientMailFields.ModuleDesc]: string;
    [ClientMailFields.MailDescAndTypeDesc]: string;
    [ClientMailFields.LastModified]: string | null;
}

export enum MailUpdateDTOFields {
    SolicitationId = 'idSolicitud',
    ClientId = 'idCliente',
    Mail = 'mail'
}

export interface MailUpdateDTO {
    [MailUpdateDTOFields.ClientId]: number,
    [MailUpdateDTOFields.SolicitationId]: number,
    [MailUpdateDTOFields.Mail]: string
}

export enum ClientNotificationFields {
    SolicitationId = 'idSolicitud',
    Type = 'tipo',
    Title = 'titulo',
    Message = 'mensaje',
    Date = 'fecha',
    Priority = 'prioridad'
}


export interface ClientNotification extends EntityWithId<number> {
    [ClientNotificationFields.SolicitationId]: number
    [ClientNotificationFields.Type]: string
    [ClientNotificationFields.Title]: string
    [ClientNotificationFields.Message]: string
    [ClientNotificationFields.Date]: Date
    [ClientNotificationFields.Priority]: boolean
}

export enum ClientRelationshipTypeClassificationFields {
    ClientRelationshipTypeCode = 'tinCodClienteRelacionTipo',
    ClientClassificationCode = 'tinCodClienteClasificacion',
    ClientClassificationDesc = 'vchDescClienteClasificacion',
    EditSigner = 'bitEditaEsFirmante',
    EditParticipation = 'bitEditaParticipacion',
}

export interface ClientRelationshipTypeClassification extends EntityWithIdAndDescription {
    [ClientRelationshipTypeClassificationFields.ClientRelationshipTypeCode]: number;
    [ClientRelationshipTypeClassificationFields.ClientClassificationCode]: number;
    [ClientRelationshipTypeClassificationFields.ClientClassificationDesc]: string;
    [ClientRelationshipTypeClassificationFields.EditSigner]: boolean;
    [ClientRelationshipTypeClassificationFields.EditParticipation]: boolean;
}